import { NavBar } from "../components/NavBar";
import { Footer } from "../components/Footer";

export function PoliticasCookiesPage() {
  return (
    <div className='min-h-screen bg-[#f6f8fb] text-slate-800 flex flex-col'>
      <NavBar isLogged={false} />

      <header className='bg-linear-to-r from-primary to-primary-hover text-white'>
        <div className='mx-auto max-w-5xl px-6 py-10'>
          <p className='text-xs uppercase tracking-[0.12em] text-white/80'>
            Legal
          </p>
          <h1 className='text-3xl font-bold'>Política de Cookies</h1>
          <p className='mt-2 text-sm md:text-base text-white/90'>
            Información sobre cómo utilizamos cookies y tecnologías similares para mejorar su experiencia en Servix.
          </p>
        </div>
      </header>

      <main className='flex-1'>
        <section className='mx-auto max-w-5xl px-6 py-12'>
          <div className='bg-white rounded-lg shadow-sm border border-slate-200 p-8 space-y-8'>
            
            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>1. ¿Qué son las Cookies?</h2>
              <p className='text-sm leading-6 text-slate-700'>
                Las cookies son pequeños archivos de texto que se almacenan en su dispositivo al visitar https://servix.com.ve/. 
                Nos ayudan a reconocer su dispositivo, mantener su sesión activa y garantizar la seguridad de la plataforma.
              </p>
            </div>

            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>2. Tipos de Cookies que Utilizamos</h2>
              <ul className='list-disc pl-5 text-sm leading-6 text-slate-700 space-y-3'>
                <li>
                  <strong>Técnicas y Necesarias:</strong> Esenciales para el funcionamiento de la plataforma, como el inicio de sesión seguro y la gestión de solicitudes de servicio.
                </li>
                <li>
                  <strong>De Rendimiento y Seguridad:</strong> Recopilan datos técnicos (logs de errores y sistema operativo) para mejorar la estabilidad de la app bajo la infraestructura de AWS.
                </li>
                <li>
                  <strong>De Sesión:</strong> Permiten mantener su cuenta activa mientras navega entre las diferentes secciones de servicios de mantenimiento.
                </li>
              </ul>
            </div>

            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>3. Finalidad</h2>
              <p className='text-sm leading-6 text-slate-700'>
                Utilizamos estas tecnologías principalmente para:
              </p>
              <ul className='list-disc pl-5 text-sm leading-6 text-slate-700 mt-2 space-y-1'>
                <li>Autenticar su identidad y prevenir accesos no autorizados.</li>
                <li>Recordar sus preferencias de ubicación para conectar con proveedores cercanos.</li>
                <li>Analizar fallos técnicos para optimizar la experiencia del usuario.</li>
              </ul>
            </div>

            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>4. Gestión y Consentimiento</h2>
              <p className='text-sm leading-6 text-slate-700'>
                Usted puede retirar su consentimiento en cualquier momento eliminando las cookies a través de la configuración de su navegador. 
                Tenga en cuenta que desactivar ciertas cookies puede afectar la funcionalidad de la plataforma Servix.
              </p>
            </div>

            <div className='bg-slate-50 border border-slate-200 p-4 rounded-md'>
              <p className='text-xs text-slate-500'>
                Para más información sobre el tratamiento de sus datos, consulte nuestra <strong>Política de Privacidad</strong> o contáctenos en <strong>admin@servix.com.ve</strong>.
              </p>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}